import { Chart } from "primereact/chart"
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IMultiBarsChart {
    weekPrevious: number[];
    weekCurrent: number[];
    type: string;
    month: string;
    year: number;
}

export const MultiBarsChart: React.FC<IMultiBarsChart> = ({ weekPrevious, weekCurrent, type, month, year }) => {
    const { t: translation } = useTranslation()
    const [currentColor, setCurrentColor] = useState('#323A80')
    const [basicData, setBasicData] = useState({
        labels: [`01/${month}/${year}`, `08/${month}/${year}`, `15/${month}/${year}`, `22/${month}/${year}`],
        datasets: [
            {
                label: 'Mês anterior',
                backgroundColor: '#DDDDDD',
                data: weekPrevious
            },
            {
                label: 'Mês atual',
                backgroundColor: '#323A80',
                data: weekCurrent
            }
        ]
    });

    useEffect(() => {

        switch (type) {
            case 'newSubscribers':
                setCurrentColor('#323A80')
                break;
            case 'totalVisitors':
                setCurrentColor('#6473FF')
                break;
            case 'totalExternalAcesses':
                setCurrentColor('#FCD3A4')
                break;
            case 'totalLinks':
                setCurrentColor('#FFAF87')
                break;

            default:
                break;
        }


        setBasicData({
            ...basicData,
            labels: [`01/${month}/${year}`, `08/${month}/${year}`, `15/${month}/${year}`, `22/${month}/${year}`],
            datasets: [
                {
                    label: translation('manager.dashboard.filterChart.months.previous'),
                    backgroundColor: '#DDDDDD',
                    data: weekPrevious,
                },
                {
                    label: translation('manager.dashboard.filterChart.months.current'),
                    backgroundColor: currentColor,
                    data: weekCurrent
                }
            ]
        })

    }, [weekCurrent, weekPrevious, type])

    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: 1,
        responsive: true,
        borderRadius: 4,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,   
                    pointStyle: 'rect',   
                    color: '#606060',
                    boxWidth: 10,
                },
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#606060'
                },
                grid: {
                    color: '#CCCCCC'
                }
            },
            y: {
                ticks: {
                    color: '#606060',
                },
                grid: {
                    color: '#CCCCCC'
                }
            }
        }
    };


    return (
        <>
            {!!weekCurrent.length && !!weekPrevious.length && (
                <Chart type="bar" data={basicData} options={basicOptions} />
            )}

        </>
    )
}